import { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // Avoid logging component data: future care content may contain PII.
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="bg-secondary/40 px-4 py-16 text-center" role="alert">
          <h2 className="font-heading text-2xl font-bold">Dit onderdeel kon niet worden geladen</h2>
          <p className="mt-3 text-muted-foreground">Vernieuw de pagina of probeer het later opnieuw.</p>
        </section>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
